import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { useT } from "@/i18n";

export default function NotFound() {
  const t = useT();
  return (
    <div className="min-h-[70vh] grid place-items-center bg-navy relative overflow-hidden" data-testid="notfound-page">
      <div className="absolute inset-0 blueprint opacity-30" />
      <div className="relative text-center px-6">
        <div className="font-display text-7xl sm:text-9xl font-extrabold text-white/90">404</div>
        <p className="text-white/70 mt-4 text-lg">{t("notfound.msg")}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-white text-navy px-6 py-3.5 font-semibold hover:bg-brand-blue hover:text-white transition-colors">
            <Home className="h-4 w-4" /> {t("notfound.home")}
          </Link>
          <Link to="/projeler" className="inline-flex items-center gap-2 rounded-full border border-white/30 text-white px-6 py-3.5 font-semibold hover:bg-white/10 transition-colors">
            <ArrowLeft className="h-4 w-4" /> {t("notfound.projects")}
          </Link>
        </div>
      </div>
    </div>
  );
}
